<template>
  <div>
    <zj-layout-container>
      <!-- <zj-layout-header>
        <div class="listtitle">区域管理</div>
        <div style="text-align: right; margin-bottom: 10px">
          <el-button @click="onAdd">新 增</el-button>
        </div>
        <el-divider></el-divider>
      </zj-layout-header> -->
      <zj-layout-main>
        <div class="zj-vehicleview-root select-none">
          <div class="box_left">
            <MapView
              ref="regionMap"
              MapKey="DefaultMap"
              MapLayers=" "
              @onAreaDrawn="onAreaDrawn"
              @onMapComplete="onMapComplete"
            ></MapView>
          </div>

          <div class="box_right">
            <ZjRegionManagerInfo
              v-if="showDetail"
              :DrawRegionInfo="drawRegionInfo"
              :RegionInfo="regionInfo"
            ></ZjRegionManagerInfo>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import MapView from "./components/RegionMapView";
import ZjRegionManagerInfo from "./RegionManagerInfo";
import ZJApp from "../../../../app";

import { getEquipmentAreaById } from "@/api/src/equipmentArea";

export default {
  name: "RegionManagerView",
  componentName: "RegionManagerView",
  components: {
    MapView,
    ZjRegionManagerInfo,
  },
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      loading: false,
      regionInfo: {},
      DrawRegionInfo: [],
      showDetail: true,
    };
  },
  created: function () {},
  mounted() {},
  methods: {
    getRegionById(id) {
      getEquipmentAreaById(id).then((response) => {
        this.regionInfo = response.data;
        setTimeout(() => {
          this.editDetail(this.regionInfo);
        }, 1000);
      });
    },
    onAdd() {
      // this.regionInfo = {};
      this.ClearOverlays();
      this.GetArea(ZJApp.ZJUtils.uuid());
    },
    onAreaDrawn: function (data) {
      this.showDetail = false;
      this.drawRegionInfo = data;
      this.$nextTick(() => {
        this.showDetail = true;
      });
    },
    onMapComplete(data) {
      const that = this;
      console.log("地图创建完成", data);
      if (this.$route.query.type == "add") {
        setTimeout(() => {
          that.onAdd();
        }, 1000);
      } else {
        if (this.$route.query.InfoId) {
          this.getRegionById(this.$route.query.InfoId);
        }
      }
    },
    handleDialogCancel() {
      this.dialogVisible = false;
      this.search();
    },
    editDetail(regionInfo) {
      regionInfo.Areas = JSON.parse(regionInfo.coordinate) || [];
      this.ClearOverlays();

      this.SetViewport(regionInfo);
      this.DrawPolygon(regionInfo);
      //如果是查看，不进行绘制功能
      if (this.$route.query.type == "query") {
        return;
      }
      if (regionInfo.Areas == null || regionInfo.Areas.length < 2) {
        //清空所有遮盖物
        this.ClearOverlays();
        //启动多边形绘制功能
        this.GetArea(ZJApp.ZJUtils.uuid());
      } else {
        this.$refs.regionMap.mapInstance.tool.DrawingArea.hide();
        //启动多边形编辑功能
        this.EditPolygon(regionInfo);
      }
    },
    handleRowClick(row) {
      this.ClearOverlays();
      this.$refs.regionMap.mapInstance.tool.PolygonEditor.hide();
      this.$refs.regionMap.mapInstance.tool.DrawingArea.hide();
      this.SetViewport(row);
      this.DrawPolygon(row);
    },

    //清空所有覆盖物
    ClearOverlays() {
      this.$refs.regionMap.mapInstance.clearAll();
    },
    //获取一个地图区域。（将启动多边形绘制功能）
    GetArea(id) {
      this.$refs.regionMap.mapInstance.tool.PolygonEditor.hide();
      this.$refs.regionMap.mapInstance.tool.DrawingArea.hide();
      this.$refs.regionMap.mapInstance.tool.DrawingArea.show();
      this.$refs.regionMap.mapInstance.tool.DrawingArea.drawPolygon({
        id: id,
      });
    },
    EditPolygon(region) {
      if (region == null || region.Areas == null || region.Areas.length == 0)
        return;
      this.$refs.regionMap.mapInstance.tool.PolygonEditor.edit(region.RegionId);
    },
    SetViewport(region) {
      const points = region.Areas.map((item) => ({
        lng: item.Longitude,
        lat: item.Latitude,
      }));
      this.$refs.regionMap.mapInstance.setViewport(points);
    },
    DrawPolygon(region) {
      const points = region.Areas.map((item) => ({
        lng: item.Longitude,
        lat: item.Latitude,
      }));
      this.$refs.regionMap.mapInstance.drawPolygon(points, region.RegionId);
    },
  },

  beforeDestroy() {},
  destroyed() {},
  controller: "UI",
  action: "RegionManagerView",
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
  display: flex;
}
.box_left {
  flex: 2;
}
.box_right {
  flex: 1;
}
</style>
